// extracted by mini-css-extract-plugin
export default {"root":"SectionHero_root__10k4c","backgroundImage":"SectionHero_backgroundImage__WsVdF","overlay":"SectionHero_overlay__VZIka","container":"SectionHero_container__NaNz-"};